<template>
  <div class="d-flex justify-content-center align-items-center" v-if="finishedLessonNumber.movies">
    <template v-if="finishedLessonNumber.finished === finishedLessonNumber.movies">
      <img src="images/statusPage/ty-success.png" alt="udało się" style="width: 24px; height: 24px" />
      <p
        v-if="collapsed"
        class="d-inline-block mb-0 ml-2"
      >Ukończyłeś wszystkie lekcje! Możesz teraz przystąpić do testu, powodzenia!</p>
    </template>
    <template v-else>
      <div class="container-progress-circle d-flex align-items-center">
        <div class="gauge-container">
          <svg class="gauge" viewBox="0 0 150 150">
            <circle class="rail" r="67" cx="75" cy="75" />
            <circle
              class="progress"
              r="67"
              data-target="84"
              cx="75"
              cy="75"
              :style="{strokeDashoffset: progressWidth}"
            />
          </svg>
        </div>
      </div>
      <p v-if="collapsed" class="d-inline-block mb-0">
        ukończyłeś
        <b>{{finishedLessonNumber.finished}}</b> z
        <b>{{finishedLessonNumber.movies}}</b> lekcji
      </p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    movies: {
      type: Number,
      required: false,
      default: 0
    },
    finishedLessons: {
      type: Number,
      required: false,
      default: 0
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    finishedLessonNumber() {
      let finished = this.finishedLessons;
      let movies = this.movies;
      return { finished, movies };
    },
    progressWidth() {
      let progress = (this.finishedLessons / this.movies) * 100;
      progress = progress > 91 && progress !== 100 ? 91 : progress;
      return `calc(440 - (440 * ${progress}) / 100)`;
    }
  }
};
</script>